import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefOBGyExaminationFetalHeartRateDescriptionDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationFetalHeartRateDescription/GetDetail?` + params, null);

export const GetRefOBGyExaminationFetalHeartRateDescriptionList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationFetalHeartRateDescription/GetList?` + params, null);

export const CreateRefOBGyExaminationFetalHeartRateDescription = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationFetalHeartRateDescription/Create`, data);

export const UpdateRefOBGyExaminationFetalHeartRateDescription = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationFetalHeartRateDescription/Update`, data);

export const DeleteRefOBGyExaminationFetalHeartRateDescription = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationFetalHeartRateDescription/Delete`, data);